<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="affiliatedEnterprises">
            <van-loading
                class="pageLogin"
                v-if="loading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="关联企业"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <ul class="list">
                    <template v-for="(item, index) in enterpriseData">
                        <li :key="index" @click="confirmSelection(item)">
                            <div class="engineeringInfo">
                                <h4 class="engineeringInfo_header">
                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                    <span class="headerName">{{ item.name }}</span>
                                </h4>
                                <span class="state">{{ item.type_name }}</span>
                                <div class="engineeringInfo_content">
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                        <span>统一信用代码：{{ item.license_code }}</span>
                                    </p>
                                    <!-- <p>
                                        <img src="@/assets/images/icons/icon_40.png" alt="">
                                        <span>客户资信：
                                            <van-rate
                                                v-model="item.credit"
                                                :allow-half="true"
                                                :readonly="true"
                                                :size="12"
                                            ></van-rate>
                                        </span>
                                    </p> -->
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_5.png" alt="">
                                        <span>客户性质：{{ item.nature_name }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_40.png" alt="">
                                        <span>客户等级：{{ item.level_name }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                        <span>关联客户：{{ item.rel_client_name }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_3.png" alt="">
                                        <span>登记人：{{ item.creator }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                        <span>登记时间：{{ item.created }}</span>
                                    </p>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 关联企业
    name: 'affiliated-enterprises',
    components: {},
    props: {},
    data() {
        return {
            // 页面login状态
            loading: false,
            // 企业数据
            enterpriseData: '',
            // 录入客户数据
            entryCustomerData: {},
            // 编辑还是新增字段
            isEdit: false,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.entryCustomerData = this.$route.query.data;
        this.isEdit = this.$route.query.isEdit;
        // 拉取客户列表数据
        this.gitCustomerData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({
                path: '/customerEntry',
                query: {
                    confirmSelection: this.entryCustomerData,
                    isEdit: this.isEdit,
                },
            });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({
                path: '/customerEntry',
                query: {
                    confirmSelection: this.entryCustomerData,
                    isEdit: this.isEdit,
                },
            });
        },
        // 拉取客户列表数据
        gitCustomerData() {
            this.$axios
                .get('/interfaceApi/sale/client_manager/get_clients')
                .then(res => {
                    this.enterpriseData = res;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    this.$dialog({ message: error });
                });
        },
        // 确认选择企业
        confirmSelection(data) {
            this.entryCustomerData.rel_client = data.id;
            this.entryCustomerData.rel_client_name = data.name;
            this.$router.isBack = 1;
            this.$router.push({
                path: '/customerEntry',
                query: {
                    confirmSelection: this.entryCustomerData,
                    isEdit: this.isEdit,
                },
            });
        },
    },
};
</script>
<style lang="stylus">
.affiliatedEnterprises
    height 100%
    section
        height calc(100% - 44rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        .list
            background #F0F0F0
            padding 15rpx
            li
                width 100%
                background #fff
                margin-bottom 14rpx
                .engineeringInfo
                    position relative
                    padding 15rpx
                    img,span
                        float left
                        height 18rpx
                        line-height 16rpx
                    img
                        width 16rpx
                        margin-right 12rpx
                    h4,p
                        overflow hidden
                    h4
                        max-width 75%
                        margin-bottom 14rpx
                        span
                            width calc(100% - 30rpx)
                            font-size 18rpx
                            line-height 20rpx
                            height 20rpx
                            color #061F3E
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                    p
                        margin-bottom 14rpx
                        &:last-child
                            margin-bottom 0
                        span
                            display block
                            width calc(100% - 30rpx)
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 14rpx
                            color #666666
                    .state
                        position absolute
                        top 15rpx
                        right 15rpx
                        font-size 12rpx
                        color #D60110
                        font-weight 600
</style>